// extracted by mini-css-extract-plugin
export default {"container":"NFTCard_container__vh+11","nft-img":"NFTCard_nft-img__a05Kn","info":"NFTCard_info__EzK4D","price-info":"NFTCard_price-info__R5Rsl","bid":"NFTCard_bid__CqaJS"};